import type { JsonData } from '@myosh/odin-components';
import { DropDown, OdinController } from '@myosh/odin-components';
import { t } from 'i18next';
import type { Control } from 'react-hook-form';
import { handleHFDropdownChange } from '../../../../helpers/dropdown';
import type { VisibleFieldType } from '../../../../redux/config/field-types-api';
import type { WidgetType } from '../../types/widget-type';

interface WidgetSecondFieldComponentInterface {
  control: Control;
  secondFieldData?: Array<VisibleFieldType>;
  widgetType?: WidgetType;
}

export const WidgetSecondFieldComponent = ({
  widgetType,
  secondFieldData,
  control,
}: WidgetSecondFieldComponentInterface) => {
  return (
    <div className="my-1">
      <OdinController
        name="secondField"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <DropDown
              allowClear={true}
              label={widgetType?.type.typeValue === 'CROSS_TAB_REPORT' ? t('fieldXAxis') : t('secondField')}
              data={secondFieldData as unknown as JsonData}
              textField="field"
              valueField="field"
              onChange={(value) => handleHFDropdownChange({ value, onChange })}
              value={value}
            />
          );
        }}
      />
    </div>
  );
};
